import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as IAction from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';

@Component({
	selector: 'promptuary-quality-modal',
	templateUrl: './promptuary-quality-modal.component.html',
	styleUrls: ['./promptuary-quality-modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PromptuaryQualityModal implements OnInit {
	shouldHideModal: boolean;
	@Input() isVisible: boolean;
	constructor(
		public translateService: TranslateService,
		public actionTrackerService: ActionTrackerService
	) {}

	ngOnInit() {
		if (this.isVisible) {
			this.actionTrackerService.eventTracker(
				IAction.SCOPE_TYPE.Promptuary,
				IAction.SUBSCOPE_TYPE.Details,
				IAction.ITEM_TYPE.PromptuaryQualityModal,
				IAction.INTERACTION_TYPE.View
			);
		}
	}

	closeModal() {
		if (this.shouldHideModal) {
			localStorage.setItem('hidePromptuaryQualityModal', 'true');
		}
		this.isVisible = false;
	}

	goToMoreAboutQualityPage() {
		window.open(
			this.translateService.instant('PROMPTUARY.QUALITY_MODAL.MORE_ABOUT.LINK'),
			'_blank'
		);
	}
}
